import { Scene } from 'three';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';
import { iApp } from '@/Interfaces/app';

export function loader(asset: string, afterLoadCb: (scene: Scene)=>void, onprogress: (percentage:number)=>void, app: iApp):Promise<unknown> {
    const promise = new Promise((resolve, reject) => {
        app.appendScene(
            asset,
            (loadedScene) => {
                // this.actions = this.app.actions;
                if (afterLoadCb)
                    afterLoadCb(loadedScene);
                resolve(loadedScene);
            },
            (percentage) => {
                if (onprogress) onprogress(percentage);
            },
            (error) => {
                reject(error);
            },
        );
    });
    return promise;
}

const gltfLoader = new GLTFLoader();

export const loadModel = function(url, modelName?) {
    return new Promise((resolve, reject) => {
        gltfLoader.load(url, function(gltf) {
            resolve(gltf.scene);
        }, undefined, (error) => {
            reject(error);
        });
    });
};
